import React from 'react';

const BackArrowIcon: React.FC = () => {
    return (
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.1568 15.8644C8.01479 16.0452 7.73077 16.0452 7.55325 15.8644L0.133136 8.30735C-0.0443792 8.12655 -0.0443792 7.87345 0.133136 7.69266L7.55325 0.135593C7.73077 -0.0451977 8.01479 -0.0451977 8.1568 0.135593C8.4341 0.403886 8.58957 0.554307 8.86686 0.822599C9.04438 1.00339 9.04438 1.29266 8.86686 1.43729L2.44083 8.01808L8.86686 14.5627C9.04438 14.7073 9.04438 14.9966 8.86686 15.1774C8.58957 15.4457 8.4341 15.5961 8.1568 15.8644Z"
                fill="#01336B"
            />
        </svg>
    );
};

export default BackArrowIcon;
